var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomGoals2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#BFBFBF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m66.435 39.63 5.109-6.812a1.846 1.846 0 0 0 .167-1.937 1.833 1.833 0 0 0-1.653-1.018h-9.9a1.85 1.85 0 0 0-1.487.735l-5.927 7.913c-.5.651-.5 1.553 0 2.22l5.944 7.915c.35.467.902.734 1.486.734h9.9c.702 0 1.336-.4 1.653-1.018a1.846 1.846 0 0 0-.167-1.937l-5.125-6.795zM44.03 37.777h4.273c-.901-6.846-6.778-12.138-13.857-12.138-7.713 0-13.991 6.278-13.991 13.99 0 7.714 6.278 13.992 13.99 13.992 7.08 0 12.957-5.293 13.858-12.138H44.03c-.868 4.508-4.842 7.914-9.583 7.914-5.393 0-9.767-4.374-9.767-9.767s4.374-9.767 9.767-9.767c4.741 0 8.715 3.406 9.583 7.914z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.733 50.866-4.441-5.91c-2.27 7.162-8.966 12.355-16.863 12.355-9.75 0-17.68-7.93-17.68-17.681 0-9.75 7.93-17.68 17.68-17.68 7.897 0 14.592 5.192 16.863 12.354l4.44-5.91a5.464 5.464 0 0 1 1.12-1.119c-4.358-7.897-12.773-13.24-22.423-13.24-14.141 0-25.594 11.47-25.594 25.595 0 14.124 11.453 25.594 25.594 25.594 9.65 0 18.065-5.342 22.422-13.24a5.464 5.464 0 0 1-1.118-1.118z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.43 37.777h5.776c-.785-2.438-3.072-4.224-5.777-4.224-3.339 0-6.077 2.721-6.077 6.077a6.078 6.078 0 0 0 6.077 6.077 6.065 6.065 0 0 0 5.777-4.224h-5.777a1.86 1.86 0 0 1-1.853-1.853c.017-1.035.835-1.853 1.853-1.853z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomGoals2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-goals-2.ef3ab3cac2d5f939b02aa909031b6f87.svg";